<template>
    <div class="banner">
      <img src="@/assets/img/play-banner.png" alt="" >
    </div>
  </template>
  
  <script>
  import KazangBanner from "@/components/layout/utils/KazangBanner";
  export default {
    name: "Header",
    components: {KazangBanner}
  }
  </script>
  
  <style scoped>
  .banner {
    height: 25vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    max-height: 280px;
    background-size: cover;
  }

  @media (min-width: 480px) {
    img {
      height: 58vh;
    }
  }
  </style>